import * as types from './actionTypes';
import { triggerError } from '../maintenanceActions';
import { cancelOperation } from '../authActions';
import createAxe from '../../middlewares/Axe'
import { Loading as i18n, SelectCoin as i18nSelectCoin, Errors as i18nErrors } from '../../middlewares/i18n';
import { goLoading, outLoading } from '../loadingActions';
import { setRates } from '../rateActions';
import { setCurrFees, setOldFees } from '../feesActions';
import { setAssetType } from '../purchaseActions';
import { LEGACY_COINS } from '../../constants/multicrypto';

export function selectCoin(coin) {
  return {
    type: types.SELECT_COIN,
    coin
  }
}

export function resetCoin() {
  return {
    type: types.RESET_COIN
  }
}

export function setEnabledCoins(enabledCoins) {
  return {
    type: types.SET_ENABLED_COINS,
    enabledCoins
  }
}

export function loadingCoins() {
  return {
    type: types.LOADING_COINS
  }
}

export function stopLoadingCoins() {
  return {
    type: types.STOP_LOADING_COINS
  }
}

// EXAMPLE RESPONSE
// {
// 	"data": [
// 		{
// 			"id": "a9c3a8ca-b891-433d-8960-efc7642d8c3e",
// 			"name": "Dogecoin",
// 			"ticker": "TDOGE",
// 			"unicode_symbol": "Ð",
// 			"decimals": 8,
// 			"price_provider": "Coinbase",
// 			"chain": {
// 				"id": "fbe91436-5b36-4ae4-8402-790952acedc4",
// 				"name": "Dogecoin"
// 			}
// 		},
// 		{
// 			"id": "b59a8e22-dc2d-4fac-a2ee-5d9dd274118f",
// 			"name": "Usdc",
// 			"ticker": "USDC",
// 			"unicode_symbol": null,
// 			"decimals": 6,
// 			"price_provider": "Coinbase",
// 			"chain": {
// 				"id": "4a365a48-4a75-473c-80ce-32e2471b10fb",
// 				"name": "Solana"
// 			}
// 		}
// 	]
// }
export function setSelectedCoin(coin) {
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(`${coin.name} ${i18nSelectCoin[lang].selected}`))
    dispatch(selectCoin(coin));
    dispatch(setAssetType('crypto'));
    setTimeout(() => dispatch(outLoading('/terms-conditions')), 3000);
  }
}

export function getEnabledCoins() {
  return async function(dispatch, getState){
    try {
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/coins/atm/enabled', {
        method: 'GET',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        }
      })
      if(res.status === 200) {
        // Merge LEGACY_COINS with API coins - LEGACY_COINS order first, but API data replaces duplicates
        const apiCoins = res.data.data;
        const apiCoinsMap = new Map(apiCoins.map(coin => [coin.id, coin]));
        const legacyIds = new Set(LEGACY_COINS.map(coin => coin.id));
        
        // For legacy coins, use API version if available, otherwise keep legacy
        const legacyOrApiCoins = LEGACY_COINS.map(legacyCoin => 
          apiCoinsMap.get(legacyCoin.id) || legacyCoin
        );
        
        // Add API coins that aren't in legacy
        const apiCoinsNotInLegacy = apiCoins.filter(coin => !legacyIds.has(coin.id));
        
        const mergedCoins = [...legacyOrApiCoins, ...apiCoinsNotInLegacy];
        dispatch(setEnabledCoins(mergedCoins))
        setTimeout(() => dispatch(getPricing()), 1500)
      }
      // THIS WHEN WE MIGRATE BTC TO BITGO
      // else {
      //   dispatch(triggerError(i18nErrors[lang].tryLater))
      //   setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
      // }
      return dispatch(stopLoadingCoins())
    }
    catch(error){
      return dispatch(stopLoadingCoins())
      // THIS WHEN WE MIGRATE BTC TO BITGO
      // dispatch(triggerError(i18nErrors[lang].tryLater))
      // setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
    }
  }
}

function createFilteringRequest(coins) {
  return {
      "filter": {
          "operator": "or",
          "operands": coins.map(coin => ({
              "property": "symbol",
              "value": coin.ticker,
              "operator": "equal"
          }))
      }
  }
}

export function getPricing() {
  return async function(dispatch, getState){
    try {
      let axe = createAxe(getState())
      let filters = createFilteringRequest(getState().multicrypto.enabledCoins)
      let res = await axe('/pricing/v2/Crypto/summary', {
        method: 'POST',
        data: filters,
      })
      if(res.status === 200) {
        // Build a quick lookup map for enabled coins based on name and ticker to easily retrieve padding info
        const coinsForMap = getState().multicrypto.enabledCoins;

        const enabledCoinsMap = coinsForMap.reduce((map, c) => {
          map[c.name.toLowerCase()] = c;
          if (c.ticker) map[c.ticker.toUpperCase()] = c;
          return map;
        }, {});

        const stableTickers = ['USDT', 'USDC'];

        const transformedData = res.data.data.reduce((acc, coin) => {
          const enabledCoin = enabledCoinsMap[coin.name.toLowerCase()] || enabledCoinsMap[coin.symbol?.toUpperCase()] || {};

          const isStable = stableTickers.includes((coin.symbol || '').toUpperCase());

          // Stablecoins are always priced at 1 with zero padding
          const padding = enabledCoin.fees?.padding_percentage ?? 0

          let og_price = coin.price

          if(isStable) {
            og_price = 1
          }

          const paddedPrice = og_price ? og_price * (1 + padding / 100) : og_price * 1.04;

          acc[coin.name.toLowerCase()] = {
            ...coin,
            price: paddedPrice,
            padding_percentage: padding,
            base_price: coin.price // keep original for reference
          }
          return acc
        }, {})
        dispatch(setRates(transformedData))
      }
    }
    catch(error){
      console.log('error getting pricing for coins', error)
    }
  }
}

export function getPricingLite() {
  return async function(dispatch, getState){
    try {
      let axe = createAxe(getState())
      let filters = createFilteringRequest([{
        name: 'bitcoin',
        ticker: 'BTC'
      }, ...getState().multicrypto.enabledCoins])
      let res = await axe('/pricing/v2/Crypto/summary-lite', {
        method: 'POST',
        data: filters,
      })
      if(res.status === 200) {
        // Build a quick lookup map for enabled coins based on name and ticker to easily retrieve padding info
        // Add Bitcoin explicitly with a default 4% padding so it also gets padded
        const coinsForMap = [{ name: 'Bitcoin', ticker: 'BTC', fees: { padding_percentage: 4 } }, ...getState().multicrypto.enabledCoins];

        const enabledCoinsMap = coinsForMap.reduce((map, c) => {
          map[c.name.toLowerCase()] = c;
          if (c.ticker) map[c.ticker.toUpperCase()] = c;
          return map;
        }, {});

        const stableTickers = ['USDT', 'USDC'];

        const transformedData = res.data.data.reduce((acc, coin) => {
          const enabledCoin = enabledCoinsMap[coin.name.toLowerCase()] || enabledCoinsMap[coin.symbol?.toUpperCase()] || {};

          const isStable = stableTickers.includes((coin.symbol || '').toUpperCase());

          // Stablecoins are always priced at 1 with zero padding
          const padding = enabledCoin.fees?.padding_percentage ?? 0

          let og_price = coin.price

          if(isStable) {
            og_price = 1
          }

          const paddedPrice = og_price ? og_price * (1 + padding / 100) : og_price * 1.04;

          // Get existing Data and update only the pricing
          acc[coin.name.toLowerCase()] = {
            ...getState().rate.multicrypto_rates[coin.name.toLowerCase()],
            price: paddedPrice,
            padding_percentage: padding,
            base_price: coin.price // keep original for reference
          }
          return acc
        }, {})
        dispatch(setRates(transformedData))
      }
    }
    catch(error){
      console.log('error getting pricing for coins', error)
    }
  }
}